import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import MenuItem from '@mui/material/MenuItem';
import Popper, { PopperProps } from '@mui/material/Popper';
import makeStyles from '@mui/styles/makeStyles';
import Paper from '@mui/material/Paper';

const useStyles = makeStyles(theme => ({
  root: {
    '& > .MuiOutlinedInput-root': {
      height: theme.spacing(5),
      padding: theme.spacing(0, 1),
    },
  },
  container: {
    border: '1px solid #D5D8DD',
    borderRadius: theme.spacing(0.5),
  },
}));

const PopperComponent = (props: PopperProps) => (
  <Popper
    {...props}
    placement="bottom-start"
    modifiers={[
      {
        name: 'preventOverflow',
        enabled: false,
        options: {
          altBoundary: true,
        },
      },
    ]}
  />
);

export const CommonAutocomplete = ({
  id,
  keyProp,
  value,
  options,
  onChange,
  inputKey,
  errors,
  getOptionLabel,
  disabled,
  required,
}: {
  id: string;
  keyProp: string;
  value: any;
  options: any[];
  onChange: (event: any, item: any) => void;
  inputKey: string;
  errors: any;
  getOptionLabel: (option: any) => string;
  disabled: boolean;
  required?: boolean;
}) => {
  const classes = useStyles();
  return (
    <Autocomplete
      key={keyProp}
      id={id}
      aria-autocomplete="none"
      disableClearable
      onChange={onChange}
      value={value}
      options={options}
      getOptionLabel={getOptionLabel}
      disabled={disabled}
      filterOptions={createFilterOptions({
        matchFrom: 'start',
      })}
      renderInput={params => (
        <TextField
          {...params}
          classes={{ root: classes.root }}
          variant="outlined"
          error={!!errors[inputKey]}
          helperText={errors[inputKey]?.message?.toString()}
          required={required ?? true}
          aria-autocomplete="none"
          disabled={disabled}
        />
      )}
      renderOption={(props, option) => (
        <MenuItem {...props} key={option.isoCode} value={option.isoCode}>
          {option.name}
        </MenuItem>
      )}
      PopperComponent={PopperComponent}
      PaperComponent={({ children }) => (
        <Paper className={classes.container} elevation={0}>
          {children}
        </Paper>
      )}
      autoComplete={false}
      fullWidth
    />
  );
};
